import { SpeakButton } from "@/components/SpeakButton";
import { MicButton } from "@/components/MicButton";

export const GrammarRules = ({ rules, lang }) => (
  <section>
    <h2 className="font-display text-xl font-bold text-slate-900 mt-10 mb-4">Grammar rules</h2>
    <div className="space-y-4">
      {rules.map((r, i) => (
        <div key={i} data-testid={`grammar-rule-${i}`} className="rounded-2xl bg-white border border-slate-200 p-5">
          <div className="flex items-center gap-2">
            <span className="h-7 w-7 rounded-lg bg-[hsl(var(--primary-light))] text-[hsl(var(--primary-dark))] grid place-items-center text-sm font-extrabold">{i + 1}</span>
            <h3 className="font-display font-bold text-lg text-slate-900">{r.rule}</h3>
          </div>
          <p className="text-slate-700 mt-2">{r.explanation}</p>
          {r.pattern && (
            <p className="mt-3 inline-block rounded-xl bg-slate-900 text-white font-mono text-sm px-3 py-1.5">{r.pattern}</p>
          )}
          <div className="mt-3 flex items-center gap-3 rounded-xl bg-slate-50 p-3">
            <div className="flex-1">
              <p className="font-semibold text-slate-900">{r.example}</p>
              {r.romaji && <p className="text-xs text-[hsl(var(--accent-blue))] font-semibold">{r.romaji}</p>}
              <p className="text-sm text-slate-600">{r.translation}</p>
            </div>
            <SpeakButton text={r.example} lang={lang} testId={`grammar-speak-${i}`} />
            <MicButton text={r.example} romaji={r.romaji} lang={lang} testId={`grammar-mic-${i}`} />
          </div>
        </div>
      ))}
    </div>
  </section>
);
